"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ItpIcon = void 0;
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const icon_html_1 = __importDefault(require("./icon.html"));
let ItpIcon = class ItpIcon extends vue_property_decorator_1.Vue {
    fa;
    name;
    icon;
    fontScale;
    color;
    clickable;
    onIconChanged() {
        _.extend(this, this._getData());
    }
    onNameChanged() {
        _.extend(this, this._getData());
    }
    onFAChanged() {
        _.extend(this, this._getData());
    }
    data() {
        return this._getData();
    }
    _getData() {
        const icon = this.icon || this.name;
        const isWrappedIcon = icon && _.indexOf(icon, ':') > -1;
        return {
            componentName: isWrappedIcon ? 'Icon' : 'i',
            bindings: isWrappedIcon ? { icon } : {},
            className: isWrappedIcon ? null : this._getClassName(icon, this.fa)
        };
    }
    _getClassName(icon, fa) {
        if (icon && _.startsWith(icon, 'fa-')) {
            return `fas ${icon}`;
        }
        if (fa) {
            return `fas fa-${fa}`;
        }
    }
    get style() {
        const result = {};
        if (this.fontScale) {
            result['font-size'] = `${this.fontScale}em`;
        }
        if (this.color) {
            result['color'] = this.color;
        }
        if (this.clickable) {
            result['cursor'] = 'pointer';
        }
        return result;
    }
};
exports.ItpIcon = ItpIcon;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpIcon.prototype, "fa", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpIcon.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpIcon.prototype, "icon", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Number)
], ItpIcon.prototype, "fontScale", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], ItpIcon.prototype, "color", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean }),
    __metadata("design:type", Boolean)
], ItpIcon.prototype, "clickable", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('icon'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpIcon.prototype, "onIconChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('name'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpIcon.prototype, "onNameChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('fa'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ItpIcon.prototype, "onFAChanged", null);
exports.ItpIcon = ItpIcon = __decorate([
    (0, vue_property_decorator_1.Component)({ template: icon_html_1.default })
], ItpIcon);
//# sourceMappingURL=icon.js.map